import { Beech } from './beech';

export default class Logger {
	beech: Beech;

	constructor(beech: Beech) {
		this.beech = beech;

		window.onerror = this.onWindowError;
		window.addEventListener('unhandledrejection', this.onUnhandledRejection);
		jQuery(document).ajaxError(this.onAjaxError);
	}

	onUnhandledRejection = (event: PromiseRejectionEvent) => {
		const reason = event.reason;
		logg.error('unhandledrejection', { reason: reason });
		this.beech.server.sendClientLog('unhandledrejection', reason?.message ?? String(reason));
	};

	onWindowError = (event: Event | string, source?: string, lineno?: number, colno?: number, error?: Error) => {
		logg.error('window.onerror', {
			event: event,
			source: source,
			lineno: lineno,
			colno: colno,
			error: error
		});

		this.log_error(
			'Application Error',
			{
				Message: `${event}`,
				File: `${source}@${lineno}:${colno}`
			},
			error?.stack
		);

		this.beech.server.sendClientLog('window.onerror', error?.message ?? `${event}`);

		return true;
	};

	onAjaxError = (event: any, jqxhr: JQueryXHR, settings: JQueryAjaxSettings, thrownError: any) => {
		logg.error('logger >> ajaxError', {
			event: event,
			jqxhr: jqxhr,
			settings: settings,
			thrownError: thrownError
		});
		this.log_error(
			'Network Error',
			{
				Request: settings.type + ' ' + settings.url,
				Status: jqxhr.status + ' ' + jqxhr.statusText
			},
			'Data = ' + settings.data + '<br />' + 'Response = Disabled'
		); // + jqxhr.responseText);
	};

	log_error = (type: string, props: any, stack: string | undefined) => {
		let eid = Date.now();

		let msg = '';
		for (let key in props) {
			if (props.hasOwnProperty(key)) {
				msg += key + ': ' + props[key] + '<br>';
			}
		}

		jQuery('#gpsh-console').append(
			"<div id='gpsh-err" +
				eid +
				"'>" +
				"<span onclick='$(this).parent().remove()'></span>" +
				'<code>' +
				type +
				'</code> <small>' +
				new Date().toISOString() +
				' @ ' +
				Date.now() +
				'</small><br>' +
				msg +
				"<div data-toggle='collapse' data-target='#gpsh-err" +
				eid +
				"-stack'>..." +
				"<div class='collapse' id='gpsh-err" +
				eid +
				"-stack'>" +
				stack +
				'</div></div></div>'
		);
	};
}
